import type { Organization } from 'lib-shared-types-api';
import { User } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { numbersApi } from 'apis/numbers';
import { presenceActions } from 'components/presence/actions/presenceActions';
import { actions as visibilityActions } from 'middleware/visibility/actions/visibility';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

/** Represents the trigger callback function. */
type Trigger = (user: User, organization: Organization) => void;

/** A hook that dispatches legacy actions for compatibility reasons. */
export function useDispatchLegacyActions(): Trigger {
  const dispatch = useAppDispatch();

  const trigger = useCallback<Trigger>(
    async (user, _organization) => {
      await bindActionToPromise(
        dispatch,
        presenceActions.presenceGet,
      )({ user_id: user.id });

      dispatch(presenceActions.presenceGetAll(user.id));
      dispatch(visibilityActions.visibilityStart());
      dispatch(numbersApi.endpoints.readDefaultNumber.initiate());
    },
    [dispatch],
  );

  return trigger;
}
